import 'bootstrap/dist/css/bootstrap.min.css';
import './css/Pages.css';
import './css/Fonts.css';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { products } from '../content';

function Products() {
  return (
    <div className="page">
      <header className="page-header">
        <Container>
          <p className="page-eyebrow">Products</p>
          <h1 className="page-title">Applications built for how mines actually run</h1>
          <p className="page-lead">
            A full suite of safety and inspection applications complete with routing,
            approvals, and offline capabilities.
          </p>
        </Container>
      </header>

      <Container className="page-section">
        {products.map((product, index) => (
          <Row
            key={product.id}
            className={`product-row align-items-center g-5 ${index % 2 ? 'product-row-alt' : ''}`}
          >
            <Col lg={7}>
              <p className="product-index">{String(index + 1).padStart(2, '0')}</p>
              <h2 className="product-name">{product.name}</h2>
              <p className="product-tagline">{product.tagline}</p>
              <p className="product-description">{product.description}</p>
            </Col>
            <Col lg={5}>
              <div className="feature-panel">
                <p className="feature-panel-title">What you get</p>
                <ul className="feature-list">
                  {product.features.map((feature) => (
                    <li key={feature}>{feature}</li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
        ))}
      </Container>

      <section className="cta-band">
        <Container className="text-center">
          <h2 className="cta-title">Want to see one on your own data?</h2>
          <p className="cta-text">We will walk through the applications that fit your operation.</p>
          <Button variant="" as={Link} to="/contact" className="btn-light-ir">
            Request a Demo
          </Button>
        </Container>
      </section>
    </div>
  );
}

export default Products;
